import React, {useState} from "react";
import Slider from "react-slick";
import "./HistoryEventsPages.css";
import moment from 'moment';
import 'moment/locale/he';

const HistoryEventsByMonth = function (props) {
    return (       
        <React.Fragment>
            <a href={props.data.FileRef} target="_blank">
            <div className="completeHistoryEvent">
                <div className="historyEventDateContainer">
                    <span className="historyEventDateItem">{moment(props.data.MuseumHistoryEventDate).format('Do MMMM')}</span>
                </div>
                <div className="historyEventTitleList">
                    <span>{moment(props.data.MuseumHistoryEventDate).format('Do בMMMM YYYY')} {props.data.Title}</span>

                </div>
            </div>
            </a>
        </React.Fragment>
   );
}

export default HistoryEventsByMonth;
